// WARNING: This file is auto-generated. Do not edit directly.
export const baseTokens = {
  color: {
    yellow: {
      '50': '#fff7e1',
      '100': '#ffebb4',
      '200': '#ffde83',
      '300': '#fed252',
      '400': '#fec82f',
      '500': '#fdbe19',
      '600': '#fdb015',
      '700': '#fc9d14',
      '800': '#fc8c13',
      '900': '#fb6d10',
    },
    green: {
      '50': '#e1f3f3',
      '100': '#b3e0e0',
      '200': '#81cdcb',
      '300': '#4eb9b6',
      '400': '#26aaa5',
      '500': '#009a93',
      '600': '#008d85',
      '700': '#007d74',
      '800': '#026d65',
      '900': '#035148',
    },
    indaco: {
      '50': '#e8eafd',
      '100': '#c5caf8',
      '200': '#98a6fe',
      '300': '#6583ff',
      '400': '#2f66fe',
      '500': '#0049fb',
      '600': '#0040ef',
      '700': '#0035e2',
      '800': '#0028d8',
      '900': '#000dbf',
    },
    grey: {
      '0': '#ffffff',
      '100': '#f6f6f5',
      '200': '#f1f1f0',
      '300': '#e7e7e5',
      '400': '#c4c4c3',
      '500': '#a6a6a5',
      '600': '#7c7c7b',
      '700': '#686867',
      '800': '#494948',
      '900': '#272726',
      alpha: {
        '0': {
          '40': 'rgba(255, 255, 255, 0.4000)',
          '60': 'rgba(255, 255, 255, 0.6000)',
        },
        '900': {
          '8': 'rgba(39, 39, 38, 0.0800)',
          '20': 'rgba(39, 39, 38, 0.2000)',
          '40': 'rgba(39, 39, 38, 0.4000)',
          '60': 'rgba(39, 39, 38, 0.6000)',
        },
      },
    },
    sand: {
      '50': '#f4ebdf',
      '100': '#ddcdbe',
      '200': '#c1ad9a',
      '300': '#a48d75',
      '400': '#8f7458',
      '500': '#795d3c',
      '600': '#6e5336',
      '700': '#5f462c',
      '800': '#523924',
      '900': '#432b1a',
    },
    violet: {
      '50': '#f5e8fd',
      '100': '#e5c4f8',
      '200': '#d79efa',
      '300': '#c06ef7',
      '400': '#a638f5',
      '500': '#930af5',
      '600': '#8e0ae6',
      '700': '#8809d7',
      '800': '#8509ce',
      '900': '#7b09b3',
    },
    denim: {
      '50': '#d6eaf8',
      '100': '#c6e2f5',
      '200': '#93c9ec',
      '300': '#67b3e4',
      '400': '#3c9ddb',
      '500': '#2384c1',
      '600': '#1a6492',
      '700': '#32586f',
      '800': '#0c3752',
      '900': '#0d2b3f',
    },
    sage: {
      '50': '#d2f0d7',
      '100': '#ade4b5',
      '200': '#87d793',
      '300': '#60ca71',
      '400': '#3fba53',
      '500': '#319242',
      '600': '#257635',
      '700': '#185d24',
      '800': '#113b18',
      '900': '#09200d',
    },
    orange: {
      '50': '#fde1ce',
      '100': '#ffd0b2',
      '200': '#fcc39e',
      '300': '#f9a56c',
      '400': '#f7873c',
      '500': '#f56a09',
      '600': '#a74d12',
      '700': '#843806',
      '800': '#582504',
      '900': '#311502',
    },
    cinnamon: {
      '50': '#f6d2d2',
      '100': '#f4bebf',
      '200': '#efa7a8',
      '300': '#e57d7d',
      '400': '#dd5352',
      '500': '#d22a2b',
      '600': '#a92022',
      '700': '#7d1919',
      '800': '#400d0d',
      '900': '#280808',
    },
  },
  scale: {
    '0': '0px',
    '25': '1px',
    '50': '2px',
    '100': '4px',
    '200': '8px',
    '300': '12px',
    '400': '16px',
    '500': '20px',
    '600': '24px',
    '700': '28px',
    '800': '32px',
    '900': '36px',
    '1000': '40px',
    '1100': '48px',
    '1200': '80px',
    '-100': '-4px',
  },
} as const;
export type BaseTokens = typeof baseTokens;
